import React, { useState, useEffect, useCallback } from 'react';
import AdUnit from '../components/AdUnit';
import SEO from '../components/SEO';

const LoremIpsumPage = () => {
  const [generatedText, setGeneratedText] = useState('');
  const [language, setLanguage] = useState('latin');

  const languages = {
    latin: {
      name: 'Latin',
      words: [
        'lorem', 'ipsum', 'dolor', 'sit', 'amet', 'consectetur', 'adipiscing', 'elit',
        'sed', 'do', 'eiusmod', 'tempor', 'incididunt', 'ut', 'labore', 'et', 'dolore',
        'magna', 'aliqua', 'enim', 'ad', 'minim', 'veniam', 'quis', 'nostrud',
        'exercitation', 'ullamco', 'laboris', 'nisi', 'aliquip', 'ex', 'ea', 'commodo',
        'consequat', 'duis', 'aute', 'irure', 'in', 'reprehenderit', 'voluptate',
        'velit', 'esse', 'cillum', 'fugiat', 'nulla', 'pariatur', 'excepteur', 'sint',
        'occaecat', 'cupidatat', 'non', 'proident', 'sunt', 'culpa', 'qui', 'officia',
        'deserunt', 'mollit', 'anim', 'id', 'est', 'laborum'
      ],
      start: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
    english: {
      name: 'English',
      words: [
        'the', 'be', 'to', 'of', 'and', 'a', 'in', 'that', 'have', 'I',
        'it', 'for', 'not', 'on', 'with', 'he', 'as', 'you', 'do', 'at',
        'this', 'but', 'his', 'by', 'from', 'they', 'we', 'say', 'her', 'she',
        'or', 'an', 'will', 'my', 'one', 'all', 'would', 'there', 'their', 'what',
        'so', 'up', 'out', 'if', 'about', 'who', 'get', 'which', 'go', 'me',
        'when', 'make', 'can', 'like', 'time', 'no', 'just', 'him', 'know', 'take'
      ],
      start: 'The quick brown fox jumps over the lazy dog. This is a sample text for testing purposes and demonstrating the English language.'
    },
    turkish: {
      name: 'Turkish',
      words: [
        've', 'bir', 'bu', 'da', 'için', 'ile', 'o', 'de', 'var', 'olan',
        'daha', 'sonra', 'çok', 'en', 'kadar', 'ne', 'ya', 'ama', 'ancak', 'gibi',
        'üzere', 'şey', 'şu', 'her', 'hiç', 'kim', 'kendi', 'hangi', 'nasıl', 'neden',
        'tüm', 'bütün', 'bazı', 'diğer', 'yeni', 'büyük', 'küçük', 'iyi', 'kötü', 'uzun',
        'kısa', 'gelmek', 'gitmek', 'yapmak', 'etmek', 'olmak', 'demek', 'görmek', 'bilmek', 'vermek'
      ],
      start: 'Türkçe örnek metin için hazırlanmış bu paragraf, dilin zenginliğini ve akıcılığını göstermek amacıyla yazılmıştır.'
    },
    spanish: {
      name: 'Spanish',
      words: [
        'el', 'la', 'de', 'que', 'y', 'a', 'en', 'un', 'ser', 'se',
        'no', 'haber', 'por', 'con', 'su', 'para', 'como', 'estar', 'tener', 'le',
        'lo', 'todo', 'pero', 'más', 'hacer', 'o', 'poder', 'decir', 'este', 'ir',
        'otro', 'ese', 'si', 'me', 'ya', 'ver', 'porque', 'dar', 'cuando', 'él',
        'muy', 'sin', 'vez', 'mucho', 'saber', 'qué', 'sobre', 'mi', 'alguno', 'mismo'
      ],
      start: 'El veloz murciélago hindú comía feliz cardillo y kiwi. Este es un texto de ejemplo para demostrar el idioma español.'
    },
    german: {
      name: 'German',
      words: [
        'der', 'die', 'und', 'in', 'den', 'von', 'zu', 'das', 'mit', 'sich',
        'des', 'auf', 'für', 'ist', 'im', 'dem', 'nicht', 'ein', 'eine', 'als',
        'auch', 'es', 'an', 'werden', 'aus', 'er', 'hat', 'dass', 'sie', 'nach',
        'wird', 'bei', 'einer', 'um', 'am', 'sind', 'noch', 'wie', 'einem', 'über',
        'einen', 'so', 'zum', 'war', 'haben', 'nur', 'oder', 'aber', 'vor', 'zur'
      ],
      start: 'Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Dies ist ein Beispieltext zur Demonstration der deutschen Sprache.'
    },
    french: {
      name: 'French',
      words: [
        'le', 'de', 'un', 'être', 'et', 'à', 'il', 'avoir', 'ne', 'je',
        'son', 'que', 'se', 'qui', 'ce', 'dans', 'en', 'du', 'elle', 'au',
        'pour', 'pas', 'que', 'vous', 'par', 'sur', 'faire', 'plus', 'dire', 'me',
        'on', 'mon', 'lui', 'nous', 'comme', 'mais', 'pouvoir', 'avec', 'tout', 'y',
        'aller', 'voir', 'en', 'bien', 'où', 'sans', 'tu', 'ou', 'leur', 'homme'
      ],
      start: 'Portez ce vieux whisky au juge blond qui fume. Ceci est un texte exemple pour démontrer la langue française.'
    }
  };

  const generateLoremIpsum = useCallback(() => {
    const currentLang = languages[language];
    const words = currentLang.words;
    const startText = currentLang.start;

    const generateSentence = (wordCount) => {
      let sentence = [];
      for (let i = 0; i < wordCount; i++) {
        const randomWord = words[Math.floor(Math.random() * words.length)];
        sentence.push(randomWord);
      }
      sentence[0] = sentence[0].charAt(0).toUpperCase() + sentence[0].slice(1);
      return sentence.join(' ') + '.';
    };

    const generateParagraph = (wordCount = 50) => {
      let paragraph = [];
      let wordsGenerated = 0;

      while (wordsGenerated < wordCount) {
        const sentenceLength = Math.floor(Math.random() * 10) + 5;
        const sentence = generateSentence(Math.min(sentenceLength, wordCount - wordsGenerated));
        paragraph.push(sentence);
        wordsGenerated += sentenceLength;
      }

      return paragraph.join(' ');
    };

    let paragraphs = [];
    for (let i = 0; i < 5; i++) {
      if (i === 0) {
        paragraphs.push(startText + ' ' + generateParagraph(40));
      } else {
        paragraphs.push(generateParagraph(50));
      }
    }

    setGeneratedText(paragraphs.join('\n\n'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  // Generate text automatically when component mounts or language changes
  useEffect(() => {
    generateLoremIpsum();
  }, [generateLoremIpsum]);

  return (
    <div className="container" style={{ width: '90%', maxWidth: '1400px' }}>
      <SEO
        title="Lorem Ipsum | YourJSONTools"
        description="Lorem Ipsum placeholder text for your designs and mockups. Multiple language support."
        keywords="lorem ipsum, placeholder text, dummy text, filler text, text generator"
      />

      <h1>Lorem Ipsum</h1>
      <p className="tool-description">
        Lorem Ipsum placeholder text for your designs, mockups, and development projects.
      </p>

      <div className="language-selector">
        {Object.keys(languages).map((lang) => (
          <button
            key={lang}
            className={`lang-button ${language === lang ? 'active' : ''}`}
            onClick={() => setLanguage(lang)}
          >
            {languages[lang].name}
          </button>
        ))}
      </div>

      <div className="lorem-ipsum-container">
        <div className="text-output">
          {generatedText}
        </div>
      </div>

      <style>{`
        .language-selector {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 2rem;
          padding: 1.5rem;
          background: #f8f9fa;
          border: 1px solid #dee2e6;
          border-radius: 8px;
        }

        .lang-button {
          padding: 0.5rem 1.25rem;
          font-size: 0.95rem;
          font-weight: 500;
          background: white;
          color: #495057;
          border: 1px solid #ced4da;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s;
        }

        .lang-button:hover {
          background: #e9ecef;
          border-color: #adb5bd;
        }

        .lang-button.active {
          background: #007bff;
          color: white;
          border-color: #007bff;
        }

        .lang-button.active:hover {
          background: #0056b3;
          border-color: #0056b3;
        }

        .lorem-ipsum-container {
          margin-bottom: 2rem;
        }

        .text-output {
          padding: 2rem;
          background: white;
          border: 1px solid #dee2e6;
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
          font-family: 'Courier New', Courier, monospace;
          font-size: 0.95rem;
          line-height: 1.8;
          color: #212529;
          text-align: left;
          white-space: pre-wrap;
          word-wrap: break-word;
        }

        @media (max-width: 768px) {
          .language-selector {
            padding: 1rem;
            gap: 0.5rem;
          }

          .lang-button {
            padding: 0.4rem 1rem;
            font-size: 0.875rem;
          }

          .text-output {
            padding: 1rem;
            font-size: 0.875rem;
          }
        }
      `}</style>

      <AdUnit />
    </div>
  );
};

export default LoremIpsumPage;
